import {Component, HostListener, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-small-header',
  templateUrl: './small-header.component.html',
  standalone: true,
  styleUrls: ['./small-header.component.less']
})
export class SmallHeaderComponent {
  scrolled: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (!isPlatformBrowser(this.platformId)) { return; }
    let scale = window.scrollY * 1.001 / 50;
    if (scale < 1) scale = 1;
    const logo = document.getElementById('logo');
    if (logo) { logo.style.transform = "scale(" + scale + ")"; }
  }
}
